module.exports = __webpack_public_path__ + "static/media/reset-icon.ee51b099.svg";